export function parseObservabilityEnabled(raw: string | undefined): boolean {
  const value = raw?.trim().toLowerCase();
  if (!value) {
    return true;
  }

  return value !== "0" && value !== "false" && value !== "off" && value !== "no";
}

export function shouldEnableWebsiteObservability(input: {
  dsn: string | undefined;
  observabilityEnabledRaw: string | undefined;
}): boolean {
  return parseObservabilityEnabled(input.observabilityEnabledRaw) && Boolean(input.dsn?.trim());
}
